import { Component, ViewChild, TemplateRef, Input, ElementRef, Renderer2, OnChanges, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PaginationService } from 'src/app/PaginationService';
import { ActivityGridComponent } from '../activity-grid/activity-grid.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { EditorComponent } from 'src/app/editor/editor.component';
import { FlexibleFieldsComponent } from '../flexible-fields/flexible-fields.component';

@Component({
  selector: 'app-raise-in',
  templateUrl: './raise-in.component.html',
  styleUrls: ['./raise-in.component.scss']
})

export class RaiseInComponent implements OnChanges, OnInit, OnDestroy, AfterViewInit {

  infoIconSrc: string = '../../assets/img/info-yellow.png';

  @Input() raiseIncidentData: boolean = false;
  @Input() isFromHomePage: any;
  @ViewChild('flexible', { static: false }) flexibleComponent!: FlexibleFieldsComponent;
  isProcessing = true;
  incidentData: any = {};
  dateCustomClasses: DatepickerDateCustomClasses[];
  freezeIncidentGroupDropDown!: boolean;
  visibleIncidentGrid: boolean = false;
  backgroundStyle = 'blue';

  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public message: messageService, private readonly elem: ElementRef, public qmsService: qmsService, public paginationService: PaginationService,
    private readonly activityGridComponent: ActivityGridComponent, private readonly renderer: Renderer2) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    this.incidentData.impactDescription = "";
    this.incidentData.description = "";
  }

  ngOnChanges() {
    if (this.isFromHomePage) {
      this.visibleIncidentGrid = true;
      this.qmsService.selectedGroup = 0;
      this.getCall();
    }
  }

  @ViewChild('angularEditor', { static: true }) angularEditor: TemplateRef<any>;
  visibleAngularEditor: MatDialogRef<TemplateRef<any>>;
  @ViewChild('mandatoryPopup', { static: true }) mandatoryPopup: TemplateRef<any>;
  visibleMandatoryPopup: MatDialogRef<TemplateRef<any>>;

  angularEditorTextareaConfig = {
    width: '100%',
    height: 'auto',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '30px' },
  };

  mandatoryPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    disableClose: true,
    containerClass: 'theme-dark-blue',
  }

  selectedIncidentGroup: any = [];

  dropDownForIncidentGroup: any = [];
  dropDownForDepartmentCode: any = [];
  dropDownForIncidentType: any = [];
  filteredRequestedAt: any = [];
  dropDownForRequestedAt: any = [];
  dropDownForCoreBusinessArea: any = [];
  dropDownForInitiatedOnBehalf: any = [];
  dropDownForImpactType: any = [];
  dropDownForIncidentReference: any = [];

  incidentGroupDropdown: any = [];
  departmentCodeDropdown: any = [];
  incidentTypeDropdown: any = [];
  requestedAtDropdown: any = [];
  coreBusinessAreaNameDropdown: any = [];
  initiatedOnBehalfDropDown: any = [];
  impactTypeDropdown: any = [];
  incidentReferenceDropdown: any = [];

  groupSearchText: string = '';
  typeSearchText: string = '';
  departmentSearchText: string = '';
  requestedSearchText: string = '';
  coreBusinessSearchText: string = '';
  referenceSearchText: string = '';
  behalfOfSearchText: string = '';
  impactTypeSearchText: string = '';

  businessAreaName: any;
  requestedAtFieldValue: any;
  coreBusinessAreaFieldValue: any;
  isForVendor: boolean;
  visibleReferenceIfOthers: boolean;
  groupDetailId: any;

  focusSearch(value: any) {
    setTimeout(() => { let searchBox = document.getElementById(value); searchBox?.focus(); }, 0)
  }

  label: any = [];
  dynamicLabel: any = null;
  groupIdForLabels: number = 0;
  getDynamicLabel(groupIdForLabels: number) {
    this.isProcessing = true;
    let groupId = groupIdForLabels == 1 ? 0 : groupIdForLabels;
    const data = {
      tableName: 'QMS_IN_GRID_VW',
      moduleName: 'IN',
      gridName: 'IN',
      groupId: groupIdForLabels ? groupId : this.qmsService.selectedGroup,
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.isProcessing = true;
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');

    const getGroupsModuleCurrentUserVw$ = this.appService.getQmsGroupsByModule("IN");
    const getQmsSettingVw$ = this.appService.getQmsSettingVw();
    const getQmsBusinessAreaDetails$ = this.appService.getAllQmsBusinessAreas();
    const getCodeListsByImpactType$ = this.appService.getCodeListsByGroup("INCIDENT_IMPACT_TYPE");
    const getCodeListsByIncidentReference$ = this.appService.getCodeListsByGroup("INCIDENT_REFERENCE");
    const getListOfUsers$ = this.appService.getModuleBasedPrivilegedUsersList('QMS');
    this.groupIdForLabels = 0;

    forkJoin([
      getGroupsModuleCurrentUserVw$,
      getQmsSettingVw$.pipe(
        catchError(() => of({ defaultIncidentGroupId: null })),
        map((data: any) => data as { defaultIncidentGroupId: number | null })
      ),
      getQmsBusinessAreaDetails$,
      getCodeListsByImpactType$,
      getCodeListsByIncidentReference$,
      getListOfUsers$
    ]).subscribe(([groupsData, qmsSettingData, businessAreaData, impactTypeData, incidentReferenceData, listOfUsers]) => {

      this.dropDownForIncidentGroup = groupsData;
      this.selectBoxForGroupValue();

      if (this.message.showIncidentSwitch) {
        if (qmsSettingData.defaultIncidentGroupId) {
          this.freezeIncidentGroupDropDown = true;
          const matchingGroup = this.dropDownForIncidentGroup.find((group: any) => group.groupId === qmsSettingData.defaultIncidentGroupId);
          if (matchingGroup) {
            this.selectedIncidentGroup = this.groupIdForLabels = matchingGroup.groupId;
          } else {
            this.groupIdForLabels = 1;
          }

          this.appService.getQmsGroupDetailsByModule(matchingGroup.groupId, "IN").subscribe((data: any) => {
            this.groupDetailId = data.groupDetailId;
            this.qmsService.selectedGroupDetailData = data;
            this.qmsService.selectedGroupDetailId = this.groupDetailId;

            this.appService.getTypeSettingsByGrpIdGrpDetailId(matchingGroup.groupId, this.groupDetailId).subscribe((response: any) => {
              this.dropDownForIncidentType = response;
              this.selectBoxForIncidentType();
            });
          });
        } else if (this.raiseIncidentData) {
          this.freezeIncidentGroupDropDown = true;
          this.appService.getQmsGroupDetailsByModule(this.selectedIncidentGroup[0].valueExp, "IN").subscribe((data: any) => {
            this.groupDetailId = data.groupDetailId;
            this.qmsService.selectedGroupDetailData = data;
            this.qmsService.selectedGroupDetailId = this.groupDetailId;
            this.appService.getTypeSettingsByGrpIdGrpDetailId(this.selectedIncidentGroup[0].valueExp, this.groupDetailId).subscribe((response: any) => {
              this.dropDownForIncidentType = response;
              this.selectBoxForIncidentType();
            });
          });
        } else {
          this.groupIdForLabels = 1;
          this.freezeIncidentGroupDropDown = false;
        }
      } else {
        const matchingGroup = this.dropDownForIncidentGroup.find((group: any) => group.groupId === this.qmsService.selectedActivityGroupId);
        this.freezeIncidentGroupDropDown = true;
        if (matchingGroup) {
          this.selectedIncidentGroup = matchingGroup.groupId;

          this.appService.getQmsGroupDetailsByModule(matchingGroup.groupId, this.qmsService.moduleName).subscribe((data: any) => {
            this.groupDetailId = data.groupDetailId;
            this.qmsService.selectedGroupDetailData = data;
            this.qmsService.selectedGroupDetailId = this.groupDetailId;
            this.appService.getTypeSettingsByGrpIdGrpDetailId(matchingGroup.groupId, this.groupDetailId).subscribe((response: any) => {
              this.dropDownForIncidentType = response;
              this.selectBoxForIncidentType();
            });
          });
        }
      }

      this.filteredRequestedAt = businessAreaData;
      this.dropDownForRequestedAt = this.filteredRequestedAt.filter((x: any) => x.module === 'IN');
      this.selectBoxForRequestedAt();

      this.dropDownForImpactType = impactTypeData;
      this.selectBoxForImpactType();

      this.dropDownForIncidentReference = incidentReferenceData;
      this.selectBoxForIncidentReference();

      this.dropDownForInitiatedOnBehalf = [];
      this.dropDownForInitiatedOnBehalf = listOfUsers;
      this.dropDownForInitiatedOnBehalf = this.dropDownForInitiatedOnBehalf.filter((x: any) => x.isActive == 'Y');
      this.selectListOfUsers();

      this.selectBoxForDepartmentCode();

      this.incidentData.isRiskCalculationReqd = this.qmsService.selectedGroupDetailData.isRiskCalculationReqd == 'Y';

      setTimeout(() => { this.getDynamicLabel(this.groupIdForLabels); }, 2000);
      this.isProcessing = false;
    });

    setTimeout(() => { this.isProcessing = false; }, 3000);
  }

  onIsOutsideOrganizationChange(event: any) {
    this.isProcessing = true;
    this.incidentData.initiatedOnBehalf = null;

    if (event.checked) {
      this.isForVendor = true;
      this.appService.getQmsVendorsVwDetails().subscribe((data: any) => {
        this.dropDownForInitiatedOnBehalf = [];
        this.dropDownForInitiatedOnBehalf = data;
        this.selectListOfUsers();
        this.isProcessing = false;
      })
    } else {
      this.isForVendor = false;
      this.appService.getOneQmsUsers().subscribe((data: any) => {
        this.dropDownForInitiatedOnBehalf = [];
        this.dropDownForInitiatedOnBehalf = data;
        this.selectListOfUsers();
        this.isProcessing = false;
      })
    }
  }

  selectBoxForGroupValue() {
    this.incidentGroupDropdown = [];
    this.incidentGroupDropdown = this.dropDownForIncidentGroup.map((item: { groupId: any; groupName: any; }) => ({
      valueExp: item.groupId,
      displayExp: item.groupName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  onGroupSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('group-validation', item);
      if (item) {
        this.isProcessing = true;
        this.appService.getQmsGroupDetailsByModule(item.valueExp, 'IN').subscribe((data: any) => {
          if (data) {
            this.groupDetailId = data.groupDetailId;
            this.qmsService.selectedGroupDetailData = data;
            this.qmsService.selectedGroupDetailId = this.groupDetailId;
            this.appService.getTypeSettingsByGrpIdGrpDetailId(this.selectedIncidentGroup[0].valueExp, this.groupDetailId).subscribe((response: any) => {
              this.dropDownForIncidentType = response;
              this.selectBoxForIncidentType();
            });
          } else {
            this.selectedIncidentGroup = null;
            this.dropDownForIncidentType = [];
            this.incidentData.inType = null;
            this.handleDropDownValidation('group-validation', []);
            this.showSnackBar("Incident Module have not added in this group " + item.displayExp + " Please contact Administrator", 'E');
          }
          this.isProcessing = false;
        });
      }
    }
  }

  selectBoxForIncidentType() {
    this.incidentTypeDropdown = [];
    this.incidentTypeDropdown = this.dropDownForIncidentType.map((item: any) => ({
      valueExp: item.type,
      displayExp: item.type
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  onIncidentTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('inType-validation', item);
      if (item) {
        this.isProcessing = true;
        this.appService.getTypeSettingsByType(this.selectedIncidentGroup, this.groupDetailId, item.valueExp).subscribe((response: any) => {
          if (response != null) {
            if (response.toBeStartedInDays) {
              const date = new Date();
              date.setHours(12);
              date.setMinutes(0);
              date.setSeconds(0);
              date.setDate(date.getDate() + response.toBeStartedInDays);
              this.incidentData.expectedToBeStartedOn = date;
              this.onNgModuleChange(this.incidentData.expectedToBeStartedOn, 'expectedToBeStartedOn-validation');
            }
            if (response.toBeClosedInDays) {
              const date = new Date();
              date.setHours(12);
              date.setMinutes(0);
              date.setSeconds(0);
              this.incidentData.expectedToBeStartedOn == null ? date.setDate(date.getDate() + response.toBeClosedInDays) : date.setDate(date.getDate() + response.toBeStartedInDays + response.toBeClosedInDays);
              this.incidentData.expcetedClosureOn = date;
              this.onNgModuleChange(this.incidentData.expcetedClosureOn, 'expcetedClosureOn-validation');
            }
          }
          this.isProcessing = false;
        })
      }
    }
  }

  selectBoxForDepartmentCode() {
    this.departmentCodeDropdown = [];
    this.departmentCodeDropdown = this.dropDownForDepartmentCode.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  onDepartmentSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('department-validation', item);
  }

  selectBoxForRequestedAt() {
    this.requestedAtDropdown = [];
    this.requestedAtDropdown = this.dropDownForRequestedAt.map((item: any) => ({
      valueExp: item.taskRequestedAt,
      displayExp: item.taskRequestedAt
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
    this.selectBoxForCoreBusinessAreaName();
  }

  isBusinessAreaEmpty: boolean = false;
  onRequestedAtSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('requestedAt-validation', item);
      setTimeout(() => { this.flexibleComponent.triggerFromRequestedAt(item.valueExp) })
      if (item) {
        this.businessAreaName = item.displayExp;

        const businessArea = this.dropDownForRequestedAt.find((task: any) => task.taskRequestedAt == item.displayExp);
        this.isBusinessAreaEmpty = businessArea ? !businessArea.listOfBusinessArea : true;
        [this.coreBusinessAreaNameDropdown, this.incidentData.coreBusinessAreaName] = [[], this.isBusinessAreaEmpty ? '' : []];

        if (!this.isBusinessAreaEmpty) {
          this.isAllBusinessAreaSelected = false;
          this.dropDownForCoreBusinessArea = businessArea.listOfBusinessArea.split(',');
          this.selectBoxForCoreBusinessAreaName();
        }
      }
    }
  }

  selectBoxForCoreBusinessAreaName() {
    this.coreBusinessAreaNameDropdown = [];
    this.coreBusinessAreaNameDropdown = this.dropDownForCoreBusinessArea.map((value: any) => ({
      valueExp: value,
      displayExp: value
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  onCoreBusinessAreaNameSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.handleDropDownValidation('business-area-validation', this.incidentData.coreBusinessAreaName);
        this.isAllBusinessAreaSelected = this.coreBusinessAreaNameDropdown.length == this.incidentData.coreBusinessAreaName.length
      });
    }
  }

  @ViewChild('businessArea') businessArea: MatSelect;
  isAllBusinessAreaSelected = false;

  toggleAllSelection(value: any) {
    if (value == 'businessArea') {
      if (this.isAllBusinessAreaSelected) this.businessArea.options.forEach((item: MatOption) => item.select());
      else this.businessArea.options.forEach((item: MatOption) => item.deselect());
    }
    this.handleDropDownValidation('business-area-validation', this.incidentData.coreBusinessAreaName);
  }

  selectBoxForIncidentReference() {
    this.incidentReferenceDropdown = [];
    this.incidentReferenceDropdown = this.dropDownForIncidentReference.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  onReferenceSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('reference-validation', item);
      if (item) {
        if (event.source.value.toLowerCase() == 'others') { this.visibleReferenceIfOthers = true; this.incidentData.referenceOthers = ''; }
        else this.visibleReferenceIfOthers = false;
      } else {
        this.visibleReferenceIfOthers = false;
      }
    }
  }

  selectBoxForImpactType() {
    this.impactTypeDropdown = [];
    this.impactTypeDropdown = this.dropDownForImpactType.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  onImpactTypeSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('impact-type-validation', item);
  }

  selectListOfUsers() {
    this.initiatedOnBehalfDropDown = this.dropDownForInitiatedOnBehalf.map((item: any) => ({
      valueExp: this.isForVendor ? item.vendorId : item.userId,
      displayExp: this.isForVendor ? item.vendorName : item.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim()));
  }

  onInitiatedOnBehalfSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('initiated-on-behalf-validation', item);
  }

  identifiedOnConfig = {
    ...this.commonDateConfig,
    maxDate: new Date()
  }

  expectedToBeStartedOnConfig = {
    ...this.commonDateConfig,
    minDate: new Date()
  }

  onExpectedToBeStartedOnChange() {
    if (this.incidentData.expcetedClosureOn && (this.incidentData.expcetedClosureOn < this.incidentData.expectedToBeStartedOn)) this.incidentData.expcetedClosureOn = null;
  }

  generateExpectedClosureDateConfig() {
    return {
      ...this.commonDateConfig,
      minDate: this.incidentData.expectedToBeStartedOn ? new Date(this.incidentData.expectedToBeStartedOn) : new Date()
    }
  }

  editorValue: any;
  textareaEditorTitle: any;
  editorName: string = '';
  openEditor(value: string) {

    this.editorName = value;
    this.editorValue = this.incidentData[this.getModel(this.editorName)] || '';
    const editorTitleMapping: Record<string, any> = {
      'Description': this.dynamicLabel?.['DESCRIPTION']?.fieldName,
      'Impact Description': this.dynamicLabel?.['IMPACT_DESCRIPTION']?.fieldName,
    };

    this.textareaEditorTitle = editorTitleMapping[this.editorName];;
    this.visibleAngularEditor = this.dialog.open(this.angularEditor, this.angularEditorTextareaConfig);
  }

  okAngularEditorData(editorValue: any) {

    this.incidentData[this.getModel(this.editorName)] = this.editorValue;
    this.visibleAngularEditor.close();
  }

  private getModel(value: string): any {
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  cancelAngularEditorData() {
    this.visibleAngularEditor.close();
  }

  config: EditorConfig = {
    buttons: [],
  };

  config1: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  detailsData(event: Event, list: any, columnIndex: number, index: any) {
    if (columnIndex === 0 && !this.message.showIncidentSwitch) {
      this.message.activityId = list.IN_NO;
      this.qmsService.activityId = list.IN_NO;
      this.message.showLeftMenu = "Main";
      this.message.breadcrumbData.fourthLevel = list.IN_ID;
      this.qmsService.selectedActivityGroupId = list.GROUP_ID;
      this.qmsService.moduleName = "IN";
      this.router.navigate(['dashboard/in']);
    }
    event.stopPropagation();
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'business-area-validation');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.error('Unable to find the element. [handleDropDownValidation()] Id → ', fieldId);
  }

  onNgModuleChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.error('Unable to find the element. [onNgModuleChange()] Id → ', fieldId);
  }

  changeToBlackColorLabel(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;

      element && (element.style.color = '#005c8a');
      !element && console.error('Unable to find the element. [changeToBlackColorLabel()] Id → ', elementId);
    });
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;

      element && (element.style.color = 'red');
      !element && console.error('Unable to find the element. [fieldValidation()] Id → ', elementId);
    });
  }

  save(incidentData: any) {

    const validations = [
      { condition: !this.selectedIncidentGroup, id: 'group-validation' },
      { condition: !incidentData.inType, id: 'inType-validation' },
      { condition: this.dynamicLabel['DEPT_NAME'].isRemovable != 'Y' && !incidentData.deptCode, id: 'department-validation' },
      { condition: !incidentData.requestedAt, id: 'requestedAt-validation' },
      { condition: incidentData.requestedAt && !this.isBusinessAreaEmpty ? !incidentData.coreBusinessAreaName?.length : !incidentData.coreBusinessAreaName, id: 'business-area-validation' },
      { condition: !incidentData.reference, id: 'reference-validation' },
      { condition: !incidentData.impactType, id: 'impact-type-validation' },
      { condition: !incidentData.impactDescription, id: 'impact-description-validation' },
      { condition: !incidentData.identifiedOn, id: 'identifiedOn-validation' },
      { condition: this.dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable != 'Y' && !incidentData.expectedToBeStartedOn, id: 'expectedToBeStartedOn-validation' },
      { condition: !incidentData.expcetedClosureOn, id: 'expcetedClosureOn-validation' },
      { condition: !incidentData.shortDescription, id: 'shortDescription-validation' },
      { condition: !incidentData.description, id: 'description-validation' },
      { condition: incidentData.initiatedOnBehalfByOthers && !incidentData.initiatedOnBehalf, id: 'initiated-on-behalf-validation' },
      { condition: incidentData.reference?.toLowerCase() === 'others' && !incidentData.referenceOthers, id: 'reference-others-validation' }
    ];

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
      this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
    } else {
      this.isProcessing = true;

      let data = {
        groupId: this.selectedIncidentGroup,
        inType: incidentData.inType,
        shortDescription: incidentData.shortDescription,
        description: incidentData.description,
        isOutsideOrganization: incidentData.isOutsideOrganization ? "Y" : "N",
        ...incidentData.initiatedOnBehalfByOthers && { initiatedOnBehalf: incidentData.initiatedOnBehalf },
        reference: incidentData.reference,
        deptCode: incidentData.deptCode,
        requestedAt: incidentData.requestedAt,
        coreBusinessAreaName: this.isBusinessAreaEmpty ? incidentData.coreBusinessAreaName : incidentData.coreBusinessAreaName?.join(','),
        referenceOthers: incidentData.referenceOthers,
        identifiedOn: this.appService.dateZoneConvertion(new Date(incidentData.identifiedOn)),
        expectedToBeStartedOn: this.appService.dateZoneConvertion(new Date(incidentData.expectedToBeStartedOn)),
        expcetedClosureOn: this.appService.dateZoneConvertion(new Date(incidentData.expcetedClosureOn)),
        impactType: incidentData.impactType,
        impactDescription: incidentData.impactDescription,
        isRiskCalculationReqd: incidentData.isRiskCalculationReqd ? "Y" : "N",
        effectivenessCheckReqd: incidentData.effectivenessCheckReqd ? "Y" : "N",
        raisedFrom: this.message.showIncidentSwitch ? "Raise" : "Manage",
      }
      this.appService.raiseIncident(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.message.lastmsg = Response;
            if (this.message.showIncidentSwitch) {
              this.showSnackBar(Response.result, Response.resultType);
              this.visibleIncidentGrid = true;
              this.getCall();
            } else {
              this.qmsService.activityId = Response.ID;
              if (this.flexibleComponent.flexibleFields.length) { this.flexibleComponent.save('Master', +Response.ID); }
              this.showSnackBar(Response.result, Response.resultType);
              this.activityGridComponent.getCall();
              this.activityGridComponent.visibleInAddPopup.close();
            }
          }
          this.isProcessing = false;
        }
      });
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  cancel() {
    this.activityGridComponent.visibleInAddPopup.close();
  }

  closeMandatoryPopup() {
    this.visibleMandatoryPopup.close();
  }

  switchView() {
    this.isProcessing = true;
    this.visibleIncidentGrid = !this.visibleIncidentGrid;
    if (this.visibleIncidentGrid) {
      this.getCall();
    }
    else {
      this.getDynamicLabel(this.groupIdForLabels);
      if (!this.freezeIncidentGroupDropDown) this.selectedIncidentGroup = [];
      [
        this.incidentData.inType,
        this.incidentData.deptCode,
        this.incidentData.requestedAt,
        this.incidentData.coreBusinessAreaName,
        this.incidentData.reference,
        this.incidentData.impactType,
        this.incidentData.initiatedOnBehalf,
        this.incidentData.identifiedOn,
        this.incidentData.expectedToBeStartedOn,
        this.incidentData.expcetedClosureOn
      ] = [null, null, null, [], null, null, null, null, null, null];
      [
        this.incidentData.referenceOthers,
        this.incidentData.shortDescription,
        this.incidentData.description,
        this.incidentData.impactDescription
      ] = ["", "", "", ""];

      this.incidentData.initiatedOnBehalfByOthers = this.incidentData.isOutsideOrganization = this.visibleReferenceIfOthers = false;

      const validatedIdsArray = [
        'group-validation', 'inType-validation', 'department-validation', 'requestedAt-validation', 'requestedAt-validation', 'business-area-validation',
        'reference-validation', 'identifiedOn-validation', 'expectedToBeStartedOn-validation', 'expcetedClosureOn-validation',
        'impact-type-validation', 'impact-description-validation', 'shortDescription-validation', 'description-validation',
      ]

      this.changeToBlackColorLabel(validatedIdsArray);
      this.isProcessing = false;
    }
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  grid: any = [];
  gridTemp: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';
  limitCharacters(event: Event, field: any) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const textLength = target.value.length;
    let charLimit: any = null;

    const fieldMapping: Record<number, string[]> = {
      // 4000: ['SHORT_DESCRIPTION', 'REFERENCE_OTHERS', 'ASSESSMENT_COMMENT', 'CLOSURE_COMMENT', 'RESOLUTION_PROVIDED'],
      1000: ['REQUESTED_AT']
    };

    for (const [limit, fields] of Object.entries(fieldMapping)) {
      if (fields.includes(field)) {
        charLimit = Number(limit);
        break;
      }
    }

    if (textLength > charLimit) {
      this.showSnackBar("Maximum " + charLimit + " Characters!", 'E');
      target.value = target.value.substring(0, charLimit);
    }
  }

  getCall() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    const data = {

      gridName: "MY_IN",
      groupId: this.qmsService.selectedGroup
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "QMS_MY_IN_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
        }
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              if (this.appService.flexiFieldModule == 'Execution_Setup') {
                if (data1.fieldColumnarray[p] != "Group Name") {
                  this.columnLists.fieldColumnarray.push({
                    "fieldColumnarray": data1.fieldColumnarray[p],
                    "width": data1.fieldSizeListArray[p] + 'px'
                  })
                }
              } else {
                this.columnLists.fieldColumnarray.push({
                  "fieldColumnarray": data1.fieldColumnarray[p],
                  "width": data1.fieldSizeListArray[p] + 'px'
                })
              }

            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const rowData of this.grid) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType === 'CHECKBOX') {
                    rowData[element.columnName] = rowData[element.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }
  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetPage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.isProcessing = false;
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  onParentChanged(e: any) {
    if (e.target.checked) {
      for (const element of this.grid) {
        element.childCheckBox = true;
      }
    } else {
      for (const element of this.grid) {
        element.childCheckBox = false;
      }
    }
  }

  onChildChanged(e: any, list: any, idx: any) {
    if (e.target.checked) {
      this.grid.every((item: any) => { if (item.childCheckBox) { item.childCheckBox = false; } return true; })
      list.childCheckBox = true;
    } else {
      this.parentCheckBox = list.childCheckBox = false;
    }
    if (this.grid.every((r: any) => r.childCheckBox)) { this.parentCheckBox = true; }
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  snackbarRef: any;
  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }

  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, columnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, columnName);
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
    this.isProcessing = false;
  }

  public focusEmpty(): void {
    console.log();
  }

}
